import { NgTemplateOutlet } from '@angular/common';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, TemplateRef } from '@angular/core';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
  selector: 'mb-base-modal',
  templateUrl: './base-modal.component.html',
  styleUrls: ['./base-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [NgTemplateOutlet, MatDialogClose],
})
export class BaseModalComponent {
  @Input() headerTpl!: TemplateRef<any>;
}
